(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-section="product-main"]');
    if (!root) return;
    var variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var addBtn = document.getElementById('add-to-cart-btn');
    var buyBtn = document.getElementById('buy-now-btn');
    var qty = document.getElementById('qty-input');

    initGhostGate(root);
    if (!addBtn || !qty) { initGallery(root.querySelector('[data-pdp-gallery]')); return; } // sold-out drop: no buy box
    var maxQty = parseInt(qty.getAttribute('max'), 10) || Infinity;

    function syncBuyNow() { if (buyBtn) buyBtn.setAttribute('href', '/cart/' + idInput.value + ':' + (parseInt(qty.value, 10) || 1)); }
    function selectVariant(id) {
      var v = variants.find(function (x) { return String(x.id) === String(id); });
      if (!v) return;
      idInput.value = v.id;
      priceEl.textContent = window.FOMO.formatMoney(v.price);
      if (compareEl) {
        var onSale = v.compare_at_price != null && Number(v.compare_at_price) > Number(v.price);
        compareEl.textContent = onSale ? window.FOMO.formatMoney(v.compare_at_price) : '';
        compareEl.hidden = !onSale;
      }
      addBtn.disabled = !v.available;
      if (v.available) { delete addBtn.dataset.soldOut; } else { addBtn.dataset.soldOut = '1'; }
      addBtn.textContent = v.available ? 'Add to Box' : 'Sold out';
      if (buyBtn) buyBtn.hidden = !v.available;
      root.querySelectorAll('.pv-variant-pill').forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-id') === String(v.id)); });
      syncBuyNow();
    }
    root.querySelectorAll('.pv-variant-pill').forEach(function (pill) {
      pill.addEventListener('click', function () { selectVariant(pill.getAttribute('data-id')); });
    });
    document.getElementById('qty-minus').addEventListener('click', function () { if (qty.value > 1) qty.value = parseInt(qty.value, 10) - 1; syncBuyNow(); });
    document.getElementById('qty-plus').addEventListener('click', function () { qty.value = Math.min(maxQty, parseInt(qty.value, 10) + 1); syncBuyNow(); });
    qty.addEventListener('change', function () { if (parseInt(qty.value, 10) > maxQty) qty.value = maxQty; syncBuyNow(); });
    syncBuyNow();

    initGallery(root.querySelector('[data-pdp-gallery]'));
  });

  // Ghost Drop: the buy box only shows when ?k= hashes (SHA-256) to the product's key hash.
  // A soft gate by design: the key only travels in the link Rudy sends to the list.
  function initGhostGate(root) {
    var gate = root.querySelector('[data-drop-ghost]');
    var gated = root.querySelector('[data-drop-gated]');
    if (!gate || !gated) return;
    var k = new URLSearchParams(window.location.search).get('k') || '';
    if (!k || !window.crypto || !window.crypto.subtle || !window.TextEncoder) return;
    window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(k)).then(function (buf) {
      var hex = Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
      if (hex === gate.getAttribute('data-key-hash')) { gate.hidden = true; gated.hidden = false; }
    });
  }

  // Photo gallery: CSS grid at >= 768px, scroll-snap carousel below. JS only keeps the
  // counter and dots in sync with the scroll position and makes the dots scroll.
  function initGallery(gallery) {
    if (!gallery) return;
    var track = gallery.querySelector('[data-pdp-track]');
    var counter = gallery.querySelector('[data-pdp-counter]');
    var dots = gallery.querySelectorAll('[data-pdp-dot]');
    var total = track ? track.querySelectorAll('[data-pdp-slide]').length : 0;
    if (!track || total < 2) return;
    var desktop = window.matchMedia('(min-width: 768px)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var active = 0;
    var ticking = false;

    function setActive(i) {
      if (i === active) return;
      active = i;
      if (counter) counter.textContent = (i + 1) + ' / ' + total;
      dots.forEach(function (d, j) {
        if (j === i) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
      });
    }
    function update() {
      ticking = false;
      var w = track.clientWidth;
      if (!w || desktop.matches) return;
      setActive(Math.max(0, Math.min(total - 1, Math.round(track.scrollLeft / w))));
    }
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      });
    });
    // The track is only a scroller (and a keyboard stop) on mobile.
    function syncMode() {
      if (desktop.matches) { track.removeAttribute('tabindex'); } else { track.setAttribute('tabindex', '0'); }
      update();
    }
    if (desktop.addEventListener) { desktop.addEventListener('change', syncMode); } else if (desktop.addListener) { desktop.addListener(syncMode); }
    syncMode();
  }
})();
